import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { longFormatDate } from '@liveauctioneers/caterwaul-components/lib/utils/dates';
import { TimedPlusStatus } from '../TimedPlusCountdown/types/TimedPlusStatus.enum';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';
import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';

export type TimedPlusEndDateProps = {
    saleEndTimestamp: number;
};

const TimedPlusEndDate = ({ saleEndTimestamp }: TimedPlusEndDateProps) => {
    const formattedDate = longFormatDate(saleEndTimestamp);

    return (
        <StyledTimedPlusEndDate>
            <FormattedMessage
                id={`itemPage.biddingInfo.timedPlus.${TimedPlusStatus.Started}.endDateOnly`}
                values={{
                    endDate: formattedDate,
                    info: (
                        <Tooltip
                            key="timed-plus-end-date-tooltip"
                            placement="bottom-end"
                            trigger={
                                <Info
                                    color="primary"
                                    key="timed-plus-end-date-info-icon"
                                    size="sm"
                                    style="fill"
                                />
                            }
                        >
                            <FormattedMessage
                                id="itemPage.biddingInfo.timedPlus.timedPlusDescription"
                                values={{
                                    helpLink: (
                                        <Link
                                            key="timed-plus-end-date-help-link"
                                            target="_blank"
                                            to="https://support.liveauctioneers.com/hc/en-gb/articles/24574071591313-How-do-Timed-auctions-work"
                                        >
                                            <FormattedMessage id="itemPage.biddingInfo.timedPlus.helpLinkText" />
                                        </Link>
                                    ),
                                }}
                            />
                        </Tooltip>
                    ),
                }}
            />
        </StyledTimedPlusEndDate>
    );
};

export default TimedPlusEndDate;

const StyledTimedPlusEndDate = styled(BodySecondary)`
    display: flex;
    & > [data-testid='popover'] {
        margin-left: 6px;
    }
`;
